// rsvp strings (es).
const rsvp = {
	rsvp: {
		going: 'Asistiré',
		maybe: 'Quizás',
		cantGo: 'No puedo ir',
		respondPrompt: '¿Vas a asistir?',
		guests: 'Invitados adicionales',
		guestsLabel: 'Número de invitados adicionales',
		note: 'Nota para el anfitrión (opcional)',
		notePlaceholder: 'Añade una nota',
		save: 'Guardar respuesta',
		saving: 'Guardando...',
		thanks: 'Gracias, tu respuesta ha sido guardada.',
		change: 'Cambiar respuesta',
		useYourLink: 'Abre tu enlace personal de invitación para responder.',
		joinOnline: 'Unirse en línea',
		addToCalendar: 'Añadir al calendario',
		googleCalendar: 'Google Calendar',
		appleOutlook: 'Apple / Outlook (.ics)',
		error: 'Algo salió mal. Inténtalo de nuevo en un momento.',
		invalid: 'Revisa tu respuesta e inténtalo de nuevo.',
		notFound: 'No se pudo encontrar esta invitación.',
		hostNote: 'Nota del anfitrión',
		decrease: 'Quitar un invitado',
		increase: 'Añadir un invitado',
		yourResponse: 'Tu respuesta',
		dashboard: {
			tab: 'RSVP',
			noReply: 'Sin respuesta',
			plusGuests: { one: '+{{count}} invitado', other: '+{{count}} invitados' },
			all: 'Todos',
			filter: 'Filtrar por respuesta',
			export: 'Exportar CSV',
			name: 'Nombre',
			email: 'Correo',
			response: 'Respuesta',
			guestsCol: 'Invitados',
			noteCol: 'Nota',
			updated: 'Actualizado',
			empty: 'Aún no hay destinatarios',
			loading: 'Cargando RSVP...',
			forbidden: 'No tienes permiso para ver los RSVP de esta tarjeta.',
			error: 'No se pudieron cargar los RSVP. Inténtalo de nuevo.',
			noMatches: 'Ningún destinatario coincide con este filtro',
			summary: 'Resumen de RSVP',
		},
	},
};

export default rsvp;
